/* eslint-disable react/prop-types */
import React from 'react';
import { useCookies } from 'react-cookie';
import { Route, Switch, Redirect } from 'react-router-dom';
import MainWrapper from '../MainWrapper';
import Landing from '../../Landing/index';
import NotFound404 from '../../DefaultPage/404/index';
import LockScreen from '../../Account/LockScreen/index';
import LogIn from '../../Account/LogIn/index';
import LogInPhoto from '../../Account/LogInPhoto/index';
import Register from '../../Account/Register/index';
import RegisterPhoto from '../../Account/RegisterPhoto/index';
import ResetPassword from '../../Account/ResetPassword/index';
import ResetPasswordPhoto from '../../Account/ResetPasswordPhoto';
import WrappedRoutes from './WrappedRoutes';
import Verification from '../../Dashboards/Verification';
import PrivacyPolicy from '../../Dashboards/PrivacyPolicy/PrivacyPolicy';
import Deleteprofilerequest from '../../Dashboards/Profile/Deleteprofilerequest';

const Router = () => (
  <MainWrapper>
    <main>
      <Switch>
        {/* <Route exact path="/" component={Landing} /> */}
        
        <Route exact path="/verify/account-confirmation" component={Verification} />
        <Route exact path="/privacypolicy" component={PrivacyPolicy} />
        <Route exact path="/deleteprofilerequest" component={Deleteprofilerequest} />
        <Route exact path="/" component={LogIn} />
        
        <Route path="/404" component={NotFound404} />
        <Route path="/lock_screen" component={LockScreen} />
        {/* log_in */}
        {/* <Route path="/log_in_photo" component={LogInPhoto} /> */}
        <Route path="/register" component={Register} />
        <Route path="/register_photo" component={RegisterPhoto} />
        <Route path="/reset_password" component={ResetPassword} />
        <Route
          path="/reset_password_photo"
          component={ResetPasswordPhoto}
        />
        <PrivateRoute path="/">
          <Route path="/" component={WrappedRoutes} />
        </PrivateRoute>
      </Switch>
    </main>
  </MainWrapper>
);


function PrivateRoute({ children, ...rest }) {
  const [cookies] = useCookies(['tranAuthToken']);
  return (
    <Route
      {...rest}
      render={({ location }) => (cookies.tranAuthToken ? (
        children
      ) : (
        <Redirect
          to={{
            pathname: '/',
            state: { from: location },
          }}
        />
      ))}
    />
  );
}

export default Router;
